export const AccessProfile = {
  Internal: 'internal',
  External: 'external',
} as const

export type AccessProfile = (typeof AccessProfile)[keyof typeof AccessProfile]

export const RequestPasswordResetStep = {
  Profile: 'profile',
  InternalInfo: 'internal_info',
  Email: 'email',
} as const

export type RequestPasswordResetStep =
  (typeof RequestPasswordResetStep)[keyof typeof RequestPasswordResetStep]

export const MODAL_TITLE_KEY_BY_STEP: Record<RequestPasswordResetStep, string> =
  {
    [RequestPasswordResetStep.Profile]: 'modal.profile_title',
    [RequestPasswordResetStep.InternalInfo]: 'modal.internal_title',
    [RequestPasswordResetStep.Email]: 'modal.email_title',
  }

export const NEXT_STEP: Record<AccessProfile, RequestPasswordResetStep> = {
  [AccessProfile.Internal]: RequestPasswordResetStep.InternalInfo,
  [AccessProfile.External]: RequestPasswordResetStep.Email,
}
